import { Select } from '@leroy-merlin-br/backyard-react-ui'
import { Controller } from 'react-hook-form'

const SelectField = ({ control, name, rules, ...props }) => (
  <Controller
    name={name}
    rules={rules}
    control={control}
    render={({ onChange, ref, value }) => <Select ref={ref} name={name} value={value} onChange={onChange} {...props} />}
  />
)

export default SelectField
